import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuoteCartModule } from './quote-cart/quote-cart.module'
import { I18nModule, provideConfig } from '@spartacus/core'
import { ConfigModule } from '@spartacus/core'
import { BrowserModule } from '@angular/platform-browser'
import { QuoteConfirmationModule } from './quote-confirmation/quote-confirmation/quote-confirmation.module'
import { QuoteTrackingModule } from './quote-tracking/quote-tracking.module'
import { NonsellableDialogComponent } from './nonsellable-dialog/nonsellable-dialog.component'
import { environment } from '../../../environments/environment'
import { DIALOG_TYPE } from '@spartacus/storefront'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'

@NgModule({
  declarations: [NonsellableDialogComponent],
  imports: [
    CommonModule,
    I18nModule,
    QuoteCartModule,
    BrowserModule,
    QuoteConfirmationModule,
    QuoteTrackingModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quote'],
        },
      },
    }),
  ],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.NON_SELLABLE_QUOTE]: {
          inlineRoot: true,
          component: NonsellableDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class QuoteModule {}
